// extracted by mini-css-extract-plugin
export var consultant = "consultant-testimonial-module--consultant--fba80";
export var consultantInfo = "consultant-testimonial-module--consultantInfo--6ecab";
export var customer = "consultant-testimonial-module--customer--d8309";
export var customerName = "consultant-testimonial-module--customerName--6dd13";
export var customerTitle = "consultant-testimonial-module--customerTitle--c53af";
export var wrapper = "consultant-testimonial-module--wrapper--b4903";